import { checkDate } from "common/helpers/Date";
import { DateStringNumber, Nullable } from ".";
import { Record } from "immutable";

export const fromJSON = (json: Partial<ISkuData>): SkuRecord => {
  const recordData: ISkuRecord = { ...(json as any) };

  if (json.created_at) {
    recordData.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    recordData.updated_at = checkDate(json.updated_at);
  }

  return new SkuRecord(recordData);
};

export interface ISkuData {
  id: number;
  item_uuid: string;
  value: string;
  org_id: number;
  loading?: boolean;

  created_at: DateStringNumber;
  updated_at: DateStringNumber;
}

export interface ISkuRecord {
  id: number;
  item_uuid: string;
  value: string;
  org_id: number;
  loading: boolean;

  created_at: Nullable<Date>;
  updated_at: Nullable<Date>;
}

const defaultSkuProps: ISkuRecord = {
  id: 0,
  item_uuid: "",
  value: "",
  org_id: 0,
  loading: false,

  created_at: null,
  updated_at: null,
};

export class SkuRecord extends Record(defaultSkuProps) implements ISkuRecord {}
